













































import { Component, Vue, Prop } from 'vue-property-decorator';
import { formatCouponDate, formatNumber } from '@/utils/helpers';
import './style.scss';

function formatDate(val: any) {
  return formatCouponDate(val);
}

@Component({
  filters: {
    formatDate,
    formatPrice(val: any) {
      let date: any = val;
      return formatNumber(date);
    }
  },
})
export default class CouponGroup extends Vue {
  @Prop() coupons!: Array<any>;
  @Prop() coupon!: any;
  @Prop() groupName!: string;
  @Prop({ default: false }) isLimit?: boolean;
  @Prop() onSelectCoupon!: Function;
  @Prop() selectCouponHandle!: Function;

  get getGroupName() {
    return this.groupName !== 'undefined' && !!this.groupName ? this.groupName : '';
  }

  handleValidMessage(item) {
    let validMessage = 'Cek masa berlaku di WhatsApp.';
    if ((item.yobo_promo_type === 6 || item.show_valid_date_type === 2) && item.end_time) {
      // Premium VIP or show Expiration Date base on setting
      validMessage = `Valid until ${formatDate(item.end_time)}`;
    } else if (item.show_valid_date_type === 1 && item.dynamic_time) {
      validMessage = `Valid until ${formatDate(item.dynamic_time)}`;
    }
    return validMessage;
  }
}
